import React, { useState } from 'react';
import { ChatItem, resolveAssetUrl } from '../../chat.api';

export function chatAvatarUrl(chat: ChatItem): string {
    // Use only the backend's visibility-filtered participant payload.
    const other = chat.participants.find(person => !person.isMe);
    return resolveAssetUrl(chat.isGroup ? chat.avatarUrl : other && other.avatarUrl);
}

export default function ChatAvatar(props: { url?: string | null; label: string; size?: string }) {
    const [failedUrl, setFailedUrl] = useState<string | null>(null);
    const url = resolveAssetUrl(props.url);
    const initials = props.label.trim().split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase() || 'ЧЧ';
    return url && url !== failedUrl
        ? <img className={'chat-avatar ' + (props.size || '')} src={url} alt={props.label} onError={() => setFailedUrl(url)} style={{objectFit: 'cover'}} />
        : <span className={'chat-avatar ' + (props.size || '')}>{initials}</span>;
}
